import { render, staticRenderFns } from "./DocumentDetailList33.vue?vue&type=template&id=22e36d72&scoped=true"
import script from "./DocumentDetailList33.vue?vue&type=script&lang=js"
export * from "./DocumentDetailList33.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e36d72",
  null
  
)

export default component.exports